<template>
  <div >
      <i @click="upBox(value)" title="编辑" style="text-align:center"><i class="el-icon-edit-outline"></i></i>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        value: null,
        number: null,
      }
    },
    mounted() {

    },
    methods: {
      upBox(value) {
        this.$emit('clickModule',value)
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>
